module.exports = __webpack_public_path__ + "img/INSTYLE-PLUS-SB3-white.8d78912a.jpg";